import { render } from "./BreadcrumbBar.vue?vue&type=template&id=24f51a77&scoped=true"
import script from "./BreadcrumbBar.vue?vue&type=script&lang=js"
export * from "./BreadcrumbBar.vue?vue&type=script&lang=js"

import "./BreadcrumbBar.vue?vue&type=style&index=0&id=24f51a77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f51a77"]])

export default __exports__